module.exports = __webpack_public_path__ + "img/video.114e3434.svg";